<template>
  <div>
    <div id="table-container">
      <ts-table :records="resources">
        <template v-slot:thead>
          <thead>
            <tr>
              <th class="text-center" rowspan="3">No</th>
              <th class="text-center" rowspan="3">Card Number</th>
              <th class="text-center" rowspan="3">Student Name</th>
              <th class="text-center" rowspan="3">Gender</th>
              <th
                class="text-center"
                :colspan="headers.t ? headers.t.length : 1"
              >
                Date
              </th>
            </tr>
            <tr>
              <th
                v-for="(columns, index) in headers.date"
                :key="index"
                :value="columns"
                colspan="2"
                class="text-center"
              >
                {{ columns }}
              </th>
            </tr>
            <tr>
              <th
                v-for="(columns, index) in headers.t"
                :key="index"
                :value="columns"
                class="text-center"
              >
                {{ columns }}
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot="{ record, index }">
          <td class="ts-whitespace-no-wrap text-center">{{ index + 1 }}</td>
          <td
            v-for="columns in columnLists"
            :key="columns"
            :value="columns"
            class="ts-whitespace-no-wrap"
            :class="
              columns == 'student_name' || columns == 'card_number'
                ? 'ts-text-left'
                : 'ts-text-center'
            "
          >
            {{ record[columns] }}
          </td>
        </template>
      </ts-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'

export default {
  name: 'summary',
  props: ['value', 'validate'],
  components: { TableProgressBar },
  data () {
    return {
      loading: false,
      showForm: false,
      headers: [],
      columnLists: [],
      model: {},
      numberlist: 1,
      errors: new Errors()
    }
  },
  created () {
    this.model = this.value
    this.getHeader()
  },
  computed: {
    ...mapState('campusAttendanceTeacher', ['resources', 'pagination'])
  },
  methods: {
    getHeader () {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('campusAttendanceTeacher/getHeader', this.model)
        .then(response => {
          this.headers = response['columnHeaders']
          this.columnLists = response['columnLists']
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  watch: {
    model: debounce(function (value) {
      this.getHeader()
    }, 500)
  }
}
</script>
<style scoped>
.no-padding-top {
  padding: 0 1rem 1rem 1rem;
}
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
